import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const LOGO = "https://customer-assets-jt897jd0.emergentagent.net/job_campana-thoughts/artifacts/wpo22urf_ChatGPT%20Image%2025%20lug%202026%2C%2009_44_00.png";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const links = [
    { to: "/", label: "Articoli" },
    { to: "/giraffe-map", label: "Giraffe Map" },
    { to: "/il-cassetto", label: "Il Cassetto" },
    { to: "/le-giraffe-consigliano", label: "Le Giraffe Consigliano" },
    { to: "/chi-sono", label: "Chi sono" },
    { to: "/sponsor", label: "Sponsor" },
    { to: "/contatti", label: "Contatti" },
  ];

  return (
    <header
      data-testid="site-header"
      className="relative z-20 bg-[#F9F8F6] border-b border-[#E7E5E4]"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-6 flex items-center justify-between">
        <Link
          to="/"
          data-testid="logo-link"
          className="group flex items-center gap-3 leading-none"
        >
          <img src={LOGO} alt="Il Cassetto delle Giraffe" className="h-12 w-auto mix-blend-multiply" />
          <span className="block">
            <span className="block font-display text-2xl md:text-[1.6rem] tracking-tight text-[#1C1917] leading-none">
              Il Cassetto delle <span className="italic text-[#9F583F]">Giraffe</span>
            </span>
            <span className="label-ui block mt-1 text-[#57534E]">di Fabio Campana</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`label-ui link-underline pb-1 ${
                pathname === l.to ? "text-[#9F583F]" : "text-[#1C1917]"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#1C1917]"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E7E5E4] px-6 py-4 flex flex-col gap-4 bg-[#F9F8F6]">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="label-ui text-[#1C1917]"
            >
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};
